export default (state={}, action) => {
  switch(action.type) {
    case 'GET_LINE_ID':
      return { ...state, ...action.payload } || false
    default:
      return state
  }
}